import { render, staticRenderFns } from "./tableOthersTasks.vue?vue&type=template&id=3a523390&scoped=true"
import script from "./tableOthersTasks.vue?vue&type=script&lang=js"
export * from "./tableOthersTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a523390",
  null
  
)

export default component.exports